// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "li.dropdown-time-selector>a[data-v-c18a2f14]{font-size:18px}li.dropdown-time-selector>a[data-v-c18a2f14]:hover,li.dropdown-time-selector>a[data-v-c18a2f14]:active,li.dropdown-time-selector>a[data-v-c18a2f14]:focus{background-color:#c9c9c9 !important;background-image:none !important}li.dropdown-time-selector-header[data-v-c18a2f14]{font-size:18px}\n", ""]);
// Exports
module.exports = exports;
